@if (autoWidth) {
  <img
    [src]="src"
    alt="logo"
    class="block w-auto"
    style="object-fit: contain"
    [class]="hStyleClass" />
} @else {
  <div class="relative w-full h-full" [class]="hStyleClass">
    <img [ngSrc]="src" alt="logo" fill priority style="object-fit: contain" />
  </div>
}
